import {
  toObject,
} from "./utils";

export const bezirke = {
  "01": "Mitte",
  "02": "Friedrichshain-Kreuzberg",
  "03": "Pankow",
  "04": "Charlottenburg-Wilmersdorf",
  "05": "Spandau",
  "06": "Steglitz-Zehlendorf",
  "07": "Tempelhof-Schöneberg",
  "08": "Neukölln",
  "09": "Treptow-Köpenick",
  "10": "Marzahn-Hellersdorf",
  "11": "Lichtenberg",
  "12": "Reinickendorf",
};

export const markerData = [{ n: "fernsehturm", lat: 52.52084869043665, lon: 13.409393064444167 }];

export const geoData = {
  layerId: "choropleth-briefwahlbezirke",
  idKey: "id",
  nameKey: "nameLong",
  regionLabel: "Stimmbezirk",
	showLabels: false,
	labelLayerId: "choropleth-briefwahlbezirke-labels",
	showSmallTooltips: false
};

export const options = [
  {
    value: "ja",
    label:"Ja",
    color: "#0050FE",
		colorDark: "#1E469C",
    colorLight: "#2D6FFF",
    dataKey: "Ja",
    legendLabel: "Stimmenmehrheit für <b>ja</b>",
  },
  {
    value: "nein",
    label:"Nein",
    color: "#E70000",
		colorDark: "#AF1616",
    colorLight: "#FF7171",
    dataKey: "Nein",
    legendLabel: "Stimmenmehrheit für <b>nein</b>",
  },
  { value: "ungueltig",
  label:"Ungültig", color: "#9B9B9B", colorLight: "#E3DDD3", dataKey: "_ungueltig_rel" },
];
export const optionsById = toObject(options, "value");

const colors = {
	cdu: "#202831",
	cduLight: "#A3A8AE",
	spd: "#E54040",
	spdLight: "#F6BFBF",
	gruene: "#30BF4F",
	grueneLight: "#75D58A",
	fdp: "#F2BF24",
	fdpLight: "#F8DB86",
	linke: "#CC52A3",
	linkeLight: "#DD8BC2",
	afd: "#36A3D9",
	afdLight: "#A6D6EE",
	sonstige: "#B2B2B2",
	sonstigeLight: "#DDDDDD",
};


export const parties = [
	{
		id: "spd",
		name: "SPD",
		description: "SPD",
		color: colors.spd,
		colorLight: colors.spdLight,
	},
	{
		id: "cdu",
		name: "CDU",
		description: "CDU",
		color: colors.cdu,
		colorLight: colors.cduLight,
	},
	{
		id: "linke",
		name: "Linke",
		description: "Die Linke",
		color: colors.linke,
		colorLight: colors.linkeLight,
	},
	{
		id: "gruene",
		name: "Grüne",
		description: "Grüne",
		color: colors.gruene,
		colorLight: colors.grueneLight,
	},
	{
		id: "afd",
		name: "AfD",
		description: "AfD",
		color: colors.afd,
		colorLight: colors.afdLight,
	},
	{
		id: "fdp",
		name: "FDP",
		description: "FDP",
		color: colors.fdp,
		colorLight: colors.fdpLight,
	},
	{
		id: "sonstige",
		name: "Sonstige",
		name_short: "Sonst.",
		description: "Sonstige",
		color: colors.sonstige,
		colorLight: colors.sonstigeLight,
	},
];
export const partiesById = toObject(parties, "id");


export const initialSelectedPoint = { lng: 13.388198546620572, lat: 52.55289914372827 };

export const initialBounds = [
  [13.761167660223435, 52.676262238895134],
  [13.073611526282605, 52.33488609760633],
];

export const initialBoundsTablet = [
  [13.211867193817284, 52.27179558551268],
  [13.899423327757603, 52.735101645391296],
];

export const maxBounds = [
  [12.758595905118852, 52.227746928806766],
  [14.076183281386392, 52.782315046335015],
];

export const baseOpacity = 0.9;
export const baseOpacityLuftbilder = 0.4;